<i18n>
{
	"en": {
		"edipartHeader" : "Maintenance EDI Parts"
	},

	"no": {
		"edipartHeader" : "Vedlikehold EDI parter"
	}
}
</i18n>

<template>
	<t-horizontal-panel>
		<EdiPartsOverview slot="left"/>
		<EditEdipart/>
	</t-horizontal-panel>
</template>

<script>

import EdiPartsOverview from './edipartMaintenance/EdipartsOverview';
import EditEdipart from './edipartMaintenance/EditEdipart';
import { mapActions } from './edipartMaintenance/store/details/ediSetupDetails.store';
export default {
	name: 'EdipartsMaintenance',
	components: { EdiPartsOverview, EditEdipart },
	computed: {},
	methods: {
		...mapActions([ 'executeSetInboundSetup', 'executeSetOutboundSetup' ]),
	}
};
</script>

<style lang="scss" scoped>

</style>